<!-- App Router Outlet :: START -->
<router-outlet></router-outlet>
<!-- App Router Outlet :: END -->
<msg91-prime-ng-toast></msg91-prime-ng-toast>
